import {
    WebGLRenderer,
    Scene,
    OrthographicCamera,
    PlaneGeometry,
    ShaderMaterial,
    Mesh,
    TextureLoader,
    Vector2
} from 'three';

import { af as AF } from '@gladeye/af';

import fragmentShader from '~/shaders/plain.frag';
import vertexShader  from '~/shaders/plain.vert';

import headerImage from '~/images/bg-8.jpg';

class App {

    constructor(){
        const el = document.querySelector('[bg-moving-canvas]');
        console.log(el);
        if (typeof el === 'undefined' || el === null) return; 

        this.fixedEl = document.querySelector('[bg-moving-fixed]');

        const { innerHeight:h, innerWidth:w } = window;

        this.renderer = new WebGLRenderer({ canvas: el, });
        this.renderer.setPixelRatio(1);
        this.scene = new Scene();
        this.cam = new OrthographicCamera(w / - 2, w / 2, h / 2, h / - 2, 1, 1000);
        this.cam.position.z = 1;


        const geo = new PlaneGeometry(w,h);
        const mat = new ShaderMaterial({
            fragmentShader,
            vertexShader,
            uniforms:{
                time:{
                    value: window.performance.now()
                },
                tDiffuse:{
                    value: null
                },
                res:{
                    value: new Vector2(w,h)
                },

                size:{
                    value: new Vector2(w,h)
                }
            }
        })

        this.mesh = new Mesh(geo, mat);
        this.scene.add(this.mesh)

        this.af = AF();
        this.af.addWrite(this.draw);

        const loader = new TextureLoader();

        loader.load(headerImage, tex => {
            this.mesh.material.uniforms.tDiffuse.value = tex;
        })

        this.resize();

        window.addEventListener( 'resize', this.resize );
    }   

    calcSize = () =>{
        const { innerHeight:h } = window;
        const w = this.fixedEl.clientWidth;
        const iw = 2048, ih = 700;

        const winRatio = w/h;
        const imageRatio = iw/ih;

        let width = 1;
        let height = 1;

        const scaleX = w / iw;
        const scaleY = h / ih;

        // console.log(scaleX, scaleY)

        if(winRatio > imageRatio) height = h / ih / scaleX;
        else width = w / iw / scaleY;

        console.log(width, height)
        
        this.mesh.material.uniforms.size.value.x = width;
        this.mesh.material.uniforms.size.value.y = height;

    }

    resize = () =>{
        const { innerHeight:h } = window;
        const w = this.fixedEl.clientWidth;
        
        this.mesh.material.uniforms.res.value.x = w;
        this.mesh.material.uniforms.res.value.y = h;

        this.calcSize();

        this.renderer.setSize(w,h);
    }

    draw = () => {
        const t = window.performance.now();

        const { pageYOffset } = window;

        // this.mesh.position.y = pageYOffset*0.1;

        this.mesh.material.uniforms.time.value = t;
        this.renderer.render(this.scene, this.cam)
    }

}


export default App;


// WEBPACK FOOTER //
// ./mysite/resources/js/components/webgl/App.js